import { ModuleRegistry } from "ag-grid-community";
import {
  LicenseManager,
  AllEnterpriseModule,
  ClientSideRowModelModule,
  ClipboardModule,
  CsvExportModule,
  ExcelExportModule,
  CellSelectionModule,
  TextEditorModule,
  ValidationModule,
} from "ag-grid-enterprise";

let initialized = false;

export const initializeAgGrid = () => {
  if (initialized) return;

const licenseKey = process.env.REACT_APP_AGGRID_LICENSE ?? "";  if (licenseKey) {
    LicenseManager.setLicenseKey(licenseKey);
  }

  ModuleRegistry.registerModules([
    AllEnterpriseModule,
    ClientSideRowModelModule,
    ClipboardModule,
    CsvExportModule,
    ExcelExportModule,
    CellSelectionModule,
    TextEditorModule,
    ...(process.env.NODE_ENV !== "production" ? [ValidationModule] : []),
  ]);

  initialized = true;
};
